// 検索結果をモーラ数でグルーピングする純関数。
// クエリと同モーラ数のグループを先頭に置き、残りはモーラ数昇順（spec の決定事項）。

import { toMorae } from '../core/vowel'
import type { WorkerResult } from '../workers/searchClient'

/** これ以上のモーラ数はひとつに束ねる（ジャンプナビのチップ数を抑える）。 */
export const GROUP_MORA_CAP = 9

export interface MoraGroup {
  /** グループのモーラ数。GROUP_MORA_CAP 以上は CAP に丸めてある。 */
  mora: number
  /** 見出し・ジャンプナビ用ラベル（例: "4", "9+"）。 */
  label: string
  items: WorkerResult[]
}

export function groupByMora(results: WorkerResult[], queryMora: number): MoraGroup[] {
  const map = new Map<number, WorkerResult[]>()
  for (const r of results) {
    const mora = Math.min(toMorae(r.reading).length, GROUP_MORA_CAP)
    const arr = map.get(mora)
    if (arr) arr.push(r)
    else map.set(mora, [r])
  }
  const q = Math.min(queryMora, GROUP_MORA_CAP)
  const moras = [...map.keys()].sort((a, b) => {
    if (a === q) return -1
    if (b === q) return 1
    return a - b
  })
  return moras.map((mora) => ({
    mora,
    label: mora >= GROUP_MORA_CAP ? `${GROUP_MORA_CAP}+` : String(mora),
    items: map.get(mora)!,
  }))
}
